import React from 'react';
import DentalServicePage from './DentalServicePage';

const SmileMakeover = () => {
    // Defined content for Smile Makeover & Teeth Whitening
    const serviceName = 'Smile Makeover & Teeth Whitening';
    const serviceTagline = 'Transform your smile with our comprehensive cosmetic dental solutions';

    const whatIsContent = [
        'A smile makeover is a personalized combination of cosmetic dental procedures designed to enhance the appearance of your smile. At Wisdom Dental Clinic, our comprehensive smile makeovers may include teeth whitening, veneers, dental bonding, gum contouring, and other treatments tailored to address your specific concerns and achieve your desired smile.',
        'Our smile makeover process begins with understanding your goals and concerns, followed by a thorough assessment of your teeth, gums, and facial features. Using advanced digital imaging and smile design technology, we create a customized treatment plan that may incorporate professional teeth whitening, porcelain veneers, composite bonding, or other cosmetic procedures to create a harmonious, natural-looking smile that complements your unique facial features.',
    ];

    const whenRequiredContent = {
        paragraphs: [
            "A smile makeover can address various cosmetic dental concerns and is ideal for those looking to comprehensively enhance their smile's appearance.",
        ],
        listIntro: 'You might consider a smile makeover if you have:',
        list: [
            'Discolored or stained teeth resistant to standard whitening',
            'Chipped, cracked, or worn teeth',
            'Gaps or spaces between teeth',
            'Misshapen or disproportionate teeth',
            'Minor misalignment issues',
            'Gummy smile or uneven gum line',
            "Multiple cosmetic concerns you'd like addressed simultaneously",
            'An upcoming special event (wedding, reunion, career opportunity)',
        ],
        closing:
            'During your consultation, our cosmetic dental specialists will discuss your aesthetic goals and recommend the most suitable combination of treatments to achieve your ideal smile.',
    };

    const howDoneContent = {
        paragraphs: [
            'At Wisdom Dental Clinic, we approach smile makeovers with artistic vision and technical precision, using the latest cosmetic dentistry techniques and materials.',
        ],
        listIntro: 'Our smile makeover services include:',
        list: [
            'Digital smile design for previewing results before treatment begins',
            'Professional-grade in-office and take-home teeth whitening',
            'Porcelain veneers crafted from premium dental ceramics',
            'Composite bonding using tooth-colored resin materials',
            'Gum contouring with advanced soft tissue lasers',
            'Cosmetic reshaping to balance tooth proportions',
            'Combination treatments for comprehensive transformation',
        ],
        closing:
            'Each procedure is performed with meticulous attention to detail, ensuring natural-looking results that enhance your facial aesthetics while maintaining proper dental function and oral health.',
    };

    const benefitsContent = [
        {
            title: 'Enhanced Appearance',
            description: 'Achieve a brighter, more balanced, and youthful smile',
        },
        {
            title: 'Boosted Confidence',
            description: 'Feel more confident in personal and professional interactions',
        },
        {
            title: 'Personalized Results',
            description: 'Custom-designed treatment plan tailored to your facial features',
        },
        {
            title: 'Improved Functionality',
            description: 'Many procedures enhance both aesthetics and dental function',
        },
        {
            title: 'Efficient Treatment',
            description: 'Combined procedures reduce overall treatment time',
        },
        {
            title: 'Long-lasting Results',
            description: 'Enjoy beautiful results that can last for many years with proper care',
        },
    ];

    const procedureSteps = [
        {
            title: 'Aesthetic Consultation',
            description:
                'In-depth discussion of your concerns, goals, and desired outcomes, with comprehensive examination of your teeth, gums, and facial features',
        },
        {
            title: 'Digital Smile Design',
            description:
                'Creation of a digital preview of your potential results using advanced imaging technology, allowing you to visualize and refine your new smile before treatment begins',
        },
        {
            title: 'Treatment Planning',
            description:
                'Development of a detailed treatment sequence, timeline, and cost estimate based on the procedures needed to achieve your desired results',
        },
        {
            title: 'Preparatory Procedures',
            description:
                'Completion of any necessary dental health treatments before beginning cosmetic procedures, such as treating decay or gum disease',
        },
        {
            title: 'Cosmetic Procedures',
            description:
                'Sequential implementation of planned treatments, which may include teeth whitening, veneers, bonding, contouring, or other cosmetic procedures',
        },
        {
            title: 'Final Refinements & Maintenance',
            description:
                'Fine-tuning of results and provision of personalized care instructions to maintain your beautiful new smile for years to come',
        },
    ];

    const seoData = {
        title: 'Smile Makeover & Teeth Whitening in Sector 23, Palam Vihar, Gurgaon',
        description:
            'Looking for the Best Smile Makeover Clinic in Sector 23, Palam Vihar, Gurgaon? Wisdom Dental Clinic offers affordable Teeth Whitening. Call now!',
        keywords:
            'Smile Makeover in Gurgaon,Best Teeth Whitening Clinic in Gurgaon,Teeth Whitening in Gurgaon,Teeth Whitening Near Me,Teeth Whitening Sector 23 gurgaon, Teeth Whitening palam vihar gurgaon',
        canonical: 'https://wisdomdentalclinics.in/smile-makeover',
        ogTitle: 'Smile Makeover & Teeth Whitening in Sector 23, Palam Vihar, Gurgaon',
        ogDescription:
            'Looking for the Best Smile Makeover Clinic in Sector 23, Palam Vihar, Gurgaon? Wisdom Dental Clinic offers affordable Teeth Whitening. Call now!',
        twitterTitle: 'Smile Makeover & Teeth Whitening in Sector 23, Palam Vihar, Gurgaon',
        twitterDescription:
            'Looking for the Best Smile Makeover Clinic in Sector 23, Palam Vihar, Gurgaon? Wisdom Dental Clinic offers affordable Teeth Whitening. Call now!',
        h1Text: 'Smile Makeover & Teeth Whitening in Sector 23 Palam Vihar Gurgaon',
    };

    return (
        <DentalServicePage
            serviceName={serviceName}
            serviceTagline={serviceTagline}
            whatIsContent={whatIsContent}
            whenRequiredContent={whenRequiredContent}
            howDoneContent={howDoneContent}
            benefitsContent={benefitsContent}
            procedureSteps={procedureSteps}
            seoData={seoData}
        />
    );
};

export default SmileMakeover;
